// greetingTheme.js
// Shared time-of-day logic used by both the greeting card (AsttHome.js) and
// the roster table card (AsttHomeRosterTable.js), so they don't each define
// their own copy of the same hour-based lookup.
import WbTwilightIcon from "@mui/icons-material/WbTwilight";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import NightsStayIcon from "@mui/icons-material/NightsStay";

// Uses the browser's local system clock (Date.getHours() reflects the
// user's own timezone automatically - no separate timezone lookup needed).
export const getTimeBasedGreetingKey = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "good_morning";
  if (hour >= 12 && hour < 17) return "good_afternoon";
  if (hour >= 17 && hour < 21) return "good_evening";
  return "welcome_back";
};

// Pairs each greeting with a sunrise -> sun -> sunset -> moon icon.
export const greetingThemeMap = {
  good_morning: { Icon: WbTwilightIcon, rotate: 0 },
  good_afternoon: { Icon: WbSunnyIcon, rotate: 0 },
  good_evening: { Icon: WbTwilightIcon, rotate: 180 },
  welcome_back: { Icon: NightsStayIcon, rotate: 0 },
};
